import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { auth } from "../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import notification from "../data/Notification";

export default function Header({ onSkin }) {
  const [user, setUser] = useState(null);
  const [fullName, setFullName] = useState("");
  const [profilePicture, setProfilePicture] = useState(null); // State for profile picture

  // Ensure sidebar skin is set to dark by default
  useEffect(() => {
    const savedSidebarSkin = localStorage.getItem("sidebar-skin");
    if (!savedSidebarSkin) {
      localStorage.setItem("sidebar-skin", "dark");
      document.querySelector("html").setAttribute("data-sidebar", "dark");
    }
  }, []);

  // Fetch the current user from Firebase and user details from Firestore
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setUser(user); // Set Firebase user data
        const userDocRef = doc(db, "Users", user.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          setFullName(userData.fullName || "User");
          setProfilePicture(userData.profilePicture || null); // Fetch profile picture
        }
      } else {
        setUser(null);
        setFullName("");
        setProfilePicture(null);
      }
    });

    return () => unsubscribe(); // Cleanup on unmount
  }, []);

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Link
      to=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className="dropdown-link"
    >
      {children}
    </Link>
  ));

  const toggleSidebar = (e) => {
    e.preventDefault();
    let isOffset = document.body.classList.contains("sidebar-offset");
    if (isOffset) {
      document.body.classList.toggle("sidebar-show");
    } else {
      if (window.matchMedia("(max-width: 991px)").matches) {
        document.body.classList.toggle("sidebar-show");
      } else {
        document.body.classList.toggle("sidebar-hide");
      }
    }
  };

  function NotificationList() {
    const notiList = notification.map((item, key) => (
      <li className="list-group-item" key={key}>
        <div
          className={item.status === "online" ? "avatar online" : "avatar"}
        >
          {item.avatar}
        </div>
        <div className="list-group-body">
          <p>{item.text}</p>
          <span>{item.date}</span>
        </div>
      </li>
    ));

    return <ul className="list-group">{notiList}</ul>;
  }

  const skinMode = (e) => {
    e.preventDefault();
    e.target.classList.add("active");

    let node = e.target.parentNode.firstChild;
    while (node) {
      if (node !== e.target && node.nodeType === Node.ELEMENT_NODE)
        node.classList.remove("active");
      node = node.nextElementSibling || node.nextSibling;
    }

    let skin = e.target.textContent.toLowerCase();
    let HTMLTag = document.querySelector("html");

    if (skin === "dark") {
      HTMLTag.setAttribute("data-skin", skin);
      localStorage.setItem("skin-mode", skin);
      
    } else {
      HTMLTag.removeAttribute("data-skin");
      localStorage.removeItem("skin-mode");
     
    }
  };

  const sidebarSkin = (e) => {
    e.preventDefault();
    e.target.classList.add("active");

    let node = e.target.parentNode.firstChild;
    while (node) {
      if (node !== e.target && node.nodeType === Node.ELEMENT_NODE)
        node.classList.remove("active");
      node = node.nextElementSibling || node.nextSibling;
    }

    let skin = e.target.textContent.toLowerCase();
    let HTMLTag = document.querySelector("html");

    HTMLTag.removeAttribute("data-sidebar");

    if (skin !== "default") {
      HTMLTag.setAttribute("data-sidebar", skin);
      localStorage.setItem("sidebar-skin", skin);
    } else {
      localStorage.removeItem("sidebar-skin");
    }
  };

  return (
    <div className="header-main px-3 px-lg-4">
      <Link onClick={toggleSidebar} className="menu-link me-3 me-lg-4">
        <i className="ri-menu-2-fill"></i>
      </Link>

      <div className="me-auto">
        {/* Placeholder for search bar */}
      </div>

      <Dropdown className="dropdown-skin" align="end">
        <Dropdown.Toggle as={CustomToggle}>
          <i className="ri-settings-3-line"></i>
        </Dropdown.Toggle>
        <Dropdown.Menu className="mt-10-f">
          <label>Skin Mode</label>
          <nav className="nav nav-skin">
            <Link
              onClick={skinMode}
              className={
                localStorage.getItem("skin-mode")
                  ? "nav-link"
                  : "nav-link active"
              }
            >
              Light
            </Link>
            <Link
              onClick={skinMode}
              className={
                localStorage.getItem("skin-mode")
                  ? "nav-link active"
                  : "nav-link"
              }
            >
              Dark
            </Link>
          </nav>
          <hr />
          <label>Sidebar Skin</label>
          <nav id="sidebarSkin" className="nav nav-skin">
            <Link
              onClick={sidebarSkin}
              className={
                !(localStorage.getItem("sidebar-skin"))
                  ? "nav-link active"
                  : "nav-link"
              }
            >
              Default
            </Link>
            <Link
              onClick={sidebarSkin}
              className={
                localStorage.getItem("sidebar-skin") === "prime"
                  ? "nav-link active"
                  : "nav-link"
              }
            >
              Prime
            </Link>
            <Link
              onClick={sidebarSkin}
              className={
                localStorage.getItem("sidebar-skin") === "dark"
                  ? "nav-link active"
                  : "nav-link"
              }
            >
              Dark
            </Link>
          </nav>
        </Dropdown.Menu>
      </Dropdown>

      <Dropdown className="dropdown-profile ms-3 ms-xl-4" align="end">
        <Dropdown.Toggle as={CustomToggle}>
          <div className="avatar online">
            {profilePicture ? (
              <img
                src={`data:image/jpeg;base64,${profilePicture}`}
                alt="User Avatar"
                className="rounded-circle"
                style={{ width: "40px", height: "40px", objectFit: "cover" }}
              />
            ) : (
              <div className="avatar-circle text-center">
                {fullName.charAt(0)}
              </div>
            )}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="mt-10-f">
          <div className="dropdown-menu-body">
            <div className="avatar avatar-xl online mb-3">
              {profilePicture ? (
                <img
                  src={`data:image/jpeg;base64,${profilePicture}`}
                  alt="User Avatar"
                  className="rounded-circle"
                />
              ) : (
                <div className="avatar-circle text-center">
                  {fullName.charAt(0)}
                </div>
              )}
            </div>
            {user && (
              <>
                <h5 className="mb-1 text-dark fw-semibold">{fullName}</h5>
                <p className="fs-sm text-secondary">{user.email}</p>
              </>
            )}
            {!user && <p className="fs-sm text-secondary">Not logged in</p>}

            <nav className="nav">
              <Link to="/pages/profile">
                <i className="ri-edit-2-line"></i> Edit Profile
              </Link>
              <Link to="/pages/profile">
                <i className="ri-profile-line"></i> View Profile
              </Link>
            </nav>
            <hr />
            <nav className="nav">
           
              <Link to="/pages/signout">
                <i className="ri-logout-box-r-line"></i> Log Out
              </Link>
            </nav>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
